import { render, staticRenderFns } from "./UsuarioIndex.vue?vue&type=template&id=3a8059d6"
import script from "./UsuarioIndex.vue?vue&type=script&lang=js"
export * from "./UsuarioIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports